<template>
    <div>
        <canvas :width="width" :height="height" ref="canvas"></canvas>
    </div>
</template>
<script>
import { Line } from 'vue-chartjs';

export default {
  extends: Line,
  name: 'LineChart',
  props: {
    width: {
        default: 600,
        type: Number
    },
    height: {
        default: 300,
        type: Number,
    },
    chartTitle: {
        type: String,
        required: true,
    },
    labels: {
        type: Array,
        required: true,
    },
    data: {
        type: Array,
        required: true,
    },

  },
  data() {
    return {
      options: {
        responsive: true, 
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }],
          xAxes: [{
            gridLines: {
              display: false,
            },
          }]
        },
        legend: {
          display: false,
        },
        title: {
          display: true,
          text: this.chartTitle || '',
          fontSize: 14,
        }
      }
    }
  },
  mounted() {
    this.renderLineChart();
  },
  watch: {
    data() {
      this.renderLineChart();
    },
    labels() {
      this.renderLineChart();
    },
    chartTitle() {
      this.options.title.text = this.chartTitle;
      this.renderLineChart
    }
  },
  methods: {
    renderLineChart() {
      const chartData = {
        labels: this.labels,
        datasets: [
          {
            backgroundColor: '#0090e9',
            borderColor: '#0090e9',
            data: this.data,
            fill: false,
          },
        ],
      };
      if (this._chart) {
        this._chart.destroy();
      }
      this.renderChart(chartData, this.options);
    }
  }
}
</script>